import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { RestApiService } from '../common-app/service/rest-api.service';
import { Kvaw0700Vo } from './kvaw0700.vo';

/**
 * サーバとの通信を行う。
 * @see WebAPI仕様_KVAW0700（過去日報一覧取得）.xlsx
 */
@Injectable()
export class Kvaw0700Service {

  /** 検索対象 */
  private static TARGET = 'kvaw0700';

  constructor(
    private restApiService: RestApiService,
  ) { }

  /**
   * 過去日報一覧情報を取得する
   *
   * @param storeCode 相手先コード
   * @param dateFrom 訪問年月日（From）
   * @param dateTo 訪問年月日（To）
   */
  searchOldReportList(storeCode?: string, dateFrom?: string, dateTo?: string): Observable<Kvaw0700Vo> {
    const query = {
      storeCode: storeCode,
      startDate: dateFrom,
      endDate: dateTo,
    };
    return this.restApiService.search<Kvaw0700Vo>(Kvaw0700Service.TARGET, query);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/kvaw0700.service.ts